export const ValidationMessageType = {
  Error: "Error",
  Warning: "Warning",
  Info: "Info",
  Success: "Success"
};
